<template>
  <div class="conversion-form">
    <div class="conversion-form-item">
      <span class="item-index">{{ index }}</span>
      <component :is="componentName" :formData="formData" />
    </div>
    <div class="opt">
      <i
        class="el-icon-document-copy"
        @click="global.handleCopyClick(formData)"
      ></i>
      <i class="el-icon-delete" @click="global.handleDelClick(formData.id)"></i>
    </div>
  </div>
</template>

<script>
import ConversionForm from "./conversionForm.vue"
import CommonForm from "./commonForm.vue"
import deepConversionForm from "./deepConversionForm.vue"
// import NonConversionForm from './commonForm.vue'
import { validNum } from '@/utils/validate'
export default {
	components: {},
	props: ["formData", 'index'],
	provide() {
		return {
      moneyRules: this.moneyRules,
      main: this,
		}
	},
	inject: ["global"],
	data() {
    const validCost = (rule, value, callback) => {
      // console.log(rule, 'rulerulerule');
     const way = this.formData.way;
			if(!validNum(value)) {
				callback(new Error('请输入正确的价格'));
			}else {
        if(+value > 0 && +value<1000000000 ) {
          if(!way) {
            return callback();
          };
          // 将数据转化为对象 方便取值
          const data = _.mapValues(_.keyBy(this.global.priceTypeList, 'value'), (v)=> _.toLower(v.label))
          // this.global.currentFloorPrice.floor_price;
          switch(rule.field) {
            case 'price': {
              const floor_price = this.global.currentFloorPrice.floor_price;
              if(floor_price[`${data[way]}_floor_price`] > value) {
                return callback(new Error(`最低出价为${floor_price[`${data[way]}_floor_price`]}`))
              }
              break;
            }
            case 'cost': {
              const conversion_price = this.global.currentFloorPrice.conversion_price;
              const conv_type = this.formData.target;
              if(!conv_type) {
                return callback();
              }
              const convTypeData = _.keyBy(conversion_price, 'conv_type');
              if(convTypeData[conv_type][`${data[way]}_floor_price`] > value) {
                return callback(new Error(`最低出价为${convTypeData[conv_type][`${data[way]}_floor_price`]}`))
              };
              break;
            }
            case 'deepCost': {
              const conversion_price = this.global.currentFloorPrice.conversion_price;
              const conv_type = this.formData.deepTarget;
              if(!conv_type) {
                return callback();
              }
              const convTypeData = _.keyBy(conversion_price, 'conv_type');
              if(convTypeData[conv_type][`${data[way]}_floor_price`] > value) {
                return callback(new Error(`最低出价为${convTypeData[conv_type][`${data[way]}_floor_price`]}`))
              };
            }
          }
          callback();
         
        }else{
          callback(new Error('请输入1000000000以下的价格'));
        }
				
			}
		}
		return {
      moneyRules: [
				{ required: true, message: '请输入' },
				{ validator: validCost, trigger: ['change', 'blur'] }
			],
    }
	},
	computed: {
		componentName() {
			const { way , deep } = this.formData;
      const conv = [ '2', '4' ] // ocpc ocpd
			if (!way ) {
				return CommonForm
			}
			if( !deep && conv.includes(way) ) {
				return ConversionForm
			};
			if(deep && conv.includes(way) ) {
				return deepConversionForm
			}
			return CommonForm
		},
    deepConversionNames() {
      let currentKey = this.global.currentKey;
      if(!this.global.isPosition) {
        const [ , displayType ] = currentKey.split('_');
        currentKey = displayType;
      }
			const target = this.formData.target
			const data = this.global.conversionNameList.find((item)=> target === item.value);
			if(!data) return [];
			return this.global.config.ocpx_deep_type.filter(item=> {
				return item.pid === `${currentKey}_${data.param_id}`;
			});
		}
	},
	methods: {
		
	},
}
</script>
<style>
.is-error + .form-item__tip {
  display: none;
}
</style>
<style lang="scss" scoped>
.conversion-form {
  display: flex;
  min-height: 170px;
  margin-bottom: 16px;
  &-item {
    flex: 1;
    width: 0;
    // height: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0;
    position: relative;
    .item-index {
      position: absolute;
      top: 10px;
      right: 10px;
      border: 1px solid #ccc;
      min-width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-radius: 15px;
      font-size: 12px;
      color: #409eff;
    }
  }
  .opt {
    width: 60px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 16px;
    i {
      display: block;
      margin-left: auto;
      font-size: 18px;
      margin-top: 20px;
      color: red;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
        color: #409eff;
      }
    }
  }
  &::v-deep .el-input-group__append {
    background: #409eff;
    color: #fff;
  }
}
</style>